import { Flex } from "@instructure/ui";
import { memo, useState } from "react";
import RichTextEditor from "react-rte";
import "./rte.css";

export const EMPTY_RTE = "<p><br></p>";

const CustomRTE = memo(
  ({ id, label, defaultValue = "", onChange, readOnly }) => {
    const [textValue, setTextValue] = useState(
      RichTextEditor.createValueFromString(defaultValue, "html")
    );

    return (
      <Flex wrap="wrap">
        <Flex.Item size="100%">
          <label
            htmlFor={id ?? "RTE"}
            style={{ marginBottom: 10, display: "block" }}
          >
            {label}
          </label>
        </Flex.Item>
        <Flex.Item size="100%">
          <RichTextEditor
            className={readOnly ? "readOnlyClass" : ""}
            id={id ?? "RTE"}
            value={textValue}
            onChange={(value) => setTextValue(value)}
            readOnly={readOnly}
            onBlur={() => {
              if (onChange) {
                onChange(textValue.toString("html"));
              }
            }}
          />
        </Flex.Item>
      </Flex>
    );
  }
);

export default CustomRTE;
